import { jsx } from "react/jsx-runtime";
import React from "react";
var shopping_basket_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.9998 3 8.062 17.9514h6.8716v2h2v-2.9187l1.1419-6.8518-9.353-2.0785L8.0187 3h-2.019zM9.805 15.9514l-.791-5.7354 6.7771 1.506-.7049 4.2294H9.8051z" }), /* @__PURE__ */ jsx("path", { d: "M8.9998 20.9514c.5522 0 1-.4477 1-1s-.4478-1-1-1c-.5523 0-1 .4477-1 1s.4477 1 1 1z" })];
};
export {
  shopping_basket_default as default
};
